import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=3e5a1e01&scoped=true"
import script from "./categorias.vue?vue&type=script&lang=js"
export * from "./categorias.vue?vue&type=script&lang=js"
import style0 from "./categorias.vue?vue&type=style&index=0&id=3e5a1e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a1e01",
  null
  
)

export default component.exports